import { render, staticRenderFns } from "./ChangeManagerRFRP.vue?vue&type=template&id=d2b46206&scoped=true"
import script from "./ChangeManagerRFRP.vue?vue&type=script&lang=js"
export * from "./ChangeManagerRFRP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b46206",
  null
  
)

export default component.exports